if (!customElements.get('modal-geo')) {
  customElements.define(
    'modal-geo',
    class ModalGeo extends HTMLElement {
      constructor() {
        super();
        
        this.config = {
          userCountryKey: 'userCountry',
          geoModalTrigger: '[data-open-geo-modal]'
        };

        this.isRedirection = new URLSearchParams(window.location.search).has('redirection');
        this.countryRedirected = this.isRedirection ? new URLSearchParams(window.location.search).get('country') : '';

        this.countries = Woolman.geoInfo.countryJson;
        this.userCountry = sessionStorage.getItem(this.config.userCountryKey);
        this.geoCurrentCountryNames = document.querySelectorAll(this.config.geoCurrentCountryName);
        this.geoModalTriggers = document.querySelectorAll(this.config.geoModalTrigger);
        this.countrySwitcher = this.querySelector('country-switcher');
        this.form = this.querySelector('form');

        if (!this.countrySwitcher) {
          return;
        }

        if (!this.isRedirection && this.userCountry == null && (!Shopify.designMode || (this.getAttribute('data-debug-mode') == 'true' && Shopify.designMode))) {
          this.runGeolocationFlow();
        }

        if (this.isRedirection && this.countryRedirected) {
          sessionStorage.setItem(this.config.userCountryKey, this.countryRedirected);
        }

        this.geoModalTriggers.forEach((trigger) => {
          trigger.addEventListener('click', function() {
            this.countrySwitcher.setSuggestedCountry(false);
            this.countrySwitcher.formatSwitcher();
            Woolman.ModalsAndDrawers.showModalOrDrawer('modal-geo');
          }.bind(this));
        });

        this.form.addEventListener('submit', function() {
          if (this.country.handle) {
            sessionStorage.setItem(this.config.userCountryKey, this.country.handle);
          }
        }.bind(this));

        document.addEventListener('drawerOrModalClose.modal-geo', function() {
          if (this.country.handle) {
            sessionStorage.setItem(this.config.userCountryKey, this.country.handle);
          }
        }.bind(this));
      }

      async fetchGeolocation() {
        try {
          const response = await fetch('/browsing_context_suggestions.json');
          const data = await response.json();
          
          return data.detected_values.country;
        } catch(err) {
          console.log(err);
        }
      }

      async runGeolocationFlow () {
        this.country = await this.fetchGeolocation();

        const subdomain =  window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false;

        if (subdomain == this.countrySwitcher.config.apacSubdomain && this.country.handle == this.countrySwitcher.config.bermudaIsoCode) {
          this.countrySwitcher.setSuggestedCountry(this.country.handle);
          this.countrySwitcher.formatSwitcher();
          Woolman.ModalsAndDrawers.showModalOrDrawer('modal-geo');

          return;
        }

        if (this.country.handle == Shopify.country) {
          sessionStorage.setItem(this.config.userCountryKey, this.country.handle);
        } else if (this.countries.findIndex(o => o.isocode == this.country.handle) > -1) {
          this.countrySwitcher.setSuggestedCountry(this.country.handle);
          this.countrySwitcher.formatSwitcher();
          Woolman.ModalsAndDrawers.showModalOrDrawer('modal-geo');
        }
      }
    }
  );
}